export default __webpack_public_path__ + "23dce6293f19c0d17c5c265a11ffe881.png";